import React from "react";
import { HiOutlineUser } from "react-icons/hi2";
import Modal from "../Components/Modal";
import Input, { FIELD_CLASS } from "./Input";
import Button from "./Button";
import DialogIntro from "./DialogIntro";

const NameModal = ({ show, onClose, onConfirm, name, setName, t }) => {
  if (!show) return null;
  return (
    <Modal
      onClose={onClose}
      isCloseIcon={false}
      isFullscreen={false}
      isBottomButton={false}
      className="p-6 w-full max-w-md m-6 bg-surface"
      isHeader={false}
    >
      <div className="flex flex-col gap-5">
        <DialogIntro
          icon={HiOutlineUser}
          title={t("Enter Your Name")}
          description={t("Who is ordering?")}
        />
        <Input
          name="name"
          type="text"
          autoComplete="name"
          className={FIELD_CLASS}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t("Your Name")}
          aria-label={t("Your Name")}
        />
        <div className="flex flex-col gap-2">
          <Button
            size="lg"
            fullWidth
            onClick={() => {
              if (onConfirm) onConfirm(name);
              onClose();
            }}
          >
            {t("Confirm")}
          </Button>
          <Button
            variant="secondary"
            fullWidth
            onClick={() => {
              onClose();
              setName("");
            }}
          >
            {t("Cancel")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NameModal;
